module.exports = __webpack_public_path__ + "doctor_12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_12.jpg
// module id = 888
// module chunks = 0